import { useMutationApi } from 'utils/api'
import { useQueryApi } from 'utils/api'

import type { UseMutationOptions, UseQueryOptions } from 'react-query'
import type { CustomError } from 'utils/customError'
import type {
  ParamsUpsertRencanaTindakLanjut,
  ParamsApiGetRencanaTindakLanjut,
  ResponseApiGetRencanaTindakLanjut,
  ResponseApiGetPenilaianRencanaTindakLanjut,
  ParamsApiGetPenilaianRencanaTindakLanjut,
  ParamsUpsertPenilaianRencanaTindakLanjut,
} from 'types/kinerja-pamong'

const BASE_PATH = '/guru/skp'

// -------------------------------------
// Upsert Rencana Tindak Lanjut
// -------------------------------------
export function useApiUpsertRencanaTindakLanjut(
  options?: UseMutationOptions<
    unknown,
    CustomError,
    ParamsUpsertRencanaTindakLanjut
  >
) {
  return useMutationApi(`${BASE_PATH}/v1/pelaksanaan/document-follow-up`, {
    axiosConfig: {
      method: 'POST',
    },
    mutationConfig: options,
  })
}

// -------------------------------------
// Get Rencana Tindak Lanjut data
// -------------------------------------
export const API_GET_RENCANA_TINDAK_LANJUT_QUERY_KEY =
  'API_GET_RENCANA_TINDAK_LANJUT_QUERY_KEY'

export function useApiGetRencanaTindakLanjut({
  params,
  options,
}: {
  params: ParamsApiGetRencanaTindakLanjut
  options?: UseQueryOptions<ResponseApiGetRencanaTindakLanjut>
}) {
  const queryKey = [
    API_GET_RENCANA_TINDAK_LANJUT_QUERY_KEY,
    params.skpYear,
    params.skpPeriod,
  ]

  return useQueryApi<ResponseApiGetRencanaTindakLanjut>(
    `${BASE_PATH}/v1/pelaksanaan/document-follow-up`,
    {
      queryConfig: {
        ...options,
      },
      axiosConfig: {
        params: {
          tipe: 'SPNF',
          ...params,
        },
      },
      queryKey,
    }
  )
}

// -------------------------------------
// Get Penilaian Rencana Tindak Lanjut data
// -------------------------------------
export const API_PAMONG_GET_PENILAIAN_RENCANA_TINDAK_LANJUT_QUERY_KEY =
  'API_PAMONG_GET_PENILAIAN_RENCANA_TINDAK_LANJUT_QUERY_KEY'

export function useApiGetPenilaianRencanaTindakLanjut({
  params,
  options,
}: {
  params: ParamsApiGetPenilaianRencanaTindakLanjut
  options?: UseQueryOptions<ResponseApiGetPenilaianRencanaTindakLanjut>
}) {
  const queryKey = [
    API_PAMONG_GET_PENILAIAN_RENCANA_TINDAK_LANJUT_QUERY_KEY,
    params.skpYear,
    params.skpPeriod,
  ]

  return useQueryApi<ResponseApiGetPenilaianRencanaTindakLanjut>(
    `${BASE_PATH}/v1/pelaksanaan/document-follow-up-evaluation`,
    {
      queryConfig: {
        ...options,
      },
      axiosConfig: {
        params: {
          tipe: 'SPNF',
          ...params,
        },
      },
      queryKey,
    }
  )
}

// -------------------------------------
// Upsert Penilaian Rencana Tindak Lanjut
// -------------------------------------
export function useApiUpsertPenilaianRencanaTindakLanjut(
  ptkId: string,
  options?: UseMutationOptions<
    unknown,
    CustomError,
    ParamsUpsertPenilaianRencanaTindakLanjut
  >
) {
  return useMutationApi(
    `${BASE_PATH}/v1/pelaksanaan/document-follow-up-evaluation/${ptkId}`,
    {
      axiosConfig: {
        method: 'POST',
      },
      mutationConfig: options,
    }
  )
}
